export class SmeltingPreheatingKilnStop {
    constructor({
        id= ``,
        date= ``,
        locName= ``,
        locId= ``,
        shiftName= ``,
        stopNumber= ``,
        stopTime= ``,
        startTime= ``,
        totalStop= ``,
        stopReason= ``,
    }={}){
        this.id = id;
        this.date = date;
        this.locName = locName;
        this.locId = locId;
        this.shiftName = shiftName;
        this.stopNumber = stopNumber;
        this.stopTime = stopTime;
        this.startTime = startTime;
        this.totalStop = totalStop;
        this.stopReason = stopReason;
    }
}

export function gridFields(){
    return Object.freeze([
        {
            key: 'date',
            label: 'lbl.basic.date',
            sortable: true,
            form: {
              type: 'datepicker'
            }
        },
        {
          key: 'locName',
          label: 'lbl.fm.locationName',
          sortable: true,
          form: {
            type: 'input'
          }
        },
        {
            key: 'shiftName',
            label: 'lbl.shiftPlan.shiftName',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'stopNumber',
            label: 'lbl.sps.stopNumber',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'stopTime',
            label: 'lbl.sps.stopTime',
            sortable: true,
            form: {
              type: 'timepicker'
            }
        },
        {
            key: 'startTime',
            label: 'lbl.sps.startTime',
            sortable: true,
            form: {
              type: 'timepicker'
            }
        },
        {
            key: 'totalStop',
            label: 'lbl.sps.totalStop',
            sortable: true,
            form: {
              type: 'input'
            }
        },
        {
            key: 'stopReason',
            label: 'lbl.sps.stopReason',
            sortable: true,
            form: {
              type: 'input'
            }
        }
    ]);
}

export const fields = Object.freeze(Object.keys(new SmeltingPreheatingKilnStop()).map(i => 'entity.'+ i));

export const filterFields = [
    'filter.startTimeFilter',
    'filter.endTimeFilter',
    'filter.shiftNameFilter',
    'filter.stopNumberFilter',
    'filter.locNameFilter',
];

export const filter = {
    'startTimeFilter':"",
    'endTimeFilter': "",
    'shiftNameFilter':"default",
    'stopNumberFilter':"",
    'locNameFilter':"default",
};